module.exports = __webpack_public_path__ + "static/Seba-b9d529e2bbe4f0f8e171ede9cbff24a2.png";